export const environment = {
  production: false,
  apiUrl: window.location.origin + '/lambda/',
  cacheUrl: window.location.origin,
  cacheToken: '',
  apiKey: 'b1d3b7f1-2e4b-4a7d-9f5e-8c2b7d6e9a10',
  okta: {
    issuer: 'https://gartner.okta.com/',
    clientId: '0oavtpglv6XrUqsLa4x7',
    redirectUri: window.location.origin + '/oauth2/idpresponse',
    scopes: ['openid', 'profile', 'email'],
    pkce: true,
    postLogoutRedirectUri: window.location.origin + '/home',
  }
};